function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.348 1.51979C13.4029 1.47953 13.4588 1.47099 13.4961 1.47099C13.5348 1.47099 13.6319 1.48142 13.7001 1.57435L15.5988 4.16424H17.2492L14.7738 0.787349C14.2772 0.110328 13.2404 -0.0510083 12.5607 0.446805L11.665 1.1032L12.452 2.17685L13.348 1.51979Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.76991 1.52038C8.8248 1.48012 8.88096 1.47095 8.91834 1.47095C8.957 1.47095 9.05413 1.48139 9.12232 1.57432L11.021 4.16421H12.6715L10.196 0.787319C9.6991 0.110298 8.66317 -0.0510388 7.9829 0.446775L2.91016 4.16421H5.16192L8.76991 1.52038Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.7407 12.6693C10.7407 11.04 12.0662 9.71426 13.6954 9.71426H18.6956V6.71305C18.6956 6.04112 18.1504 5.49512 17.478 5.49512H1.2176C0.545183 5.49508 0 6.04104 0 6.71301V18.6254C0 19.2982 0.545183 19.8434 1.2176 19.8434H17.478C18.1504 19.8434 18.6956 19.2982 18.6956 18.6254V15.6242H13.6954C12.0661 15.6242 10.7407 14.2985 10.7407 12.6693Z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M19.3529 10.7125H13.6947C12.6143 10.7125 11.7383 11.5886 11.7383 12.6693C11.7383 13.7502 12.6143 14.6261 13.6947 14.6261H19.353C19.7099 14.6261 19.9993 14.3362 19.9993 13.9801V11.3591C19.9993 11.0023 19.7098 10.7125 19.3529 10.7125Z",
  fill: "currentColor"
});

var SvgPayment = function SvgPayment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPayment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/payment.e2e0ae2a.svg";
export { ForwardRef as ReactComponent };